import co from 'co'
// const OSSConfig = {
// 	uploadHost: 'https://pimc-beta.oss-cn-hangzhou.aliyuncs.com', //OSS上传地址
//     region: 'oss-cn-hangzhou',
//     success_action_status: '200', // 默认200
//     // accessKeyId: 'LTAIRrT7bAwAowfC',
//     // accessKeySecret: 'DrEOIM9B8YTvyTpiEgQBoNNfPPMDrZ',
//     accessKeyId: 'LTAISnjq7X1brjGK',
//     accessKeySecret: 'QAhgwuGVxiLgRwN8LYAZZ9KeuNj2Bs',
//     bucket: 'pimc-beta',
// }
function uploadOSS(file,config,dir,callback) {
    return new Promise((resolve, reject) => {
        var client = new OSS({
            // region: OSSConfig.region,
            accessKeyId: config.AccessKeyId,
            accessKeySecret: config.AccessKeySecret,
            endpoint:'https://'+config.endpoint,
            bucket: config.bucket,
            stsToken:config.SecurityToken,
            secure:true
        });
        // if(type=='video'){
        //     var dir = 'uploads/videos/'
        // }else{
        //     var dir = 'uploads/screenshot/'
        // }
        co(function* () {
            var result = yield client.multipartUpload(`${config[dir]}${file.name}`, file,{
                progress:function*(percentage){
                    let loadingProgress = Math.ceil(percentage * 100)
                    callback(loadingProgress)
                }
            });
            if(result.res.statusCode==200){
                resolve({code:0,path:result.name,msg:'上传成功'});
            }else{
                resolve({code:1,msg:'上传失败'});
            }
        }).catch(function () {
            reject({code:2,msg:'连接阿里云失败'});
        });
    });
}

export { uploadOSS }


// WEBPACK FOOTER //
// ./src/assets/js/oss.js